<template>
	<div class="binding-body">
		<div class="search-box">
			<!-- <div class="input-box">
				<span style="color:red">*</span><span>销售门店：</span>
                <el-select v-model="shopid" class="name-input" size='mini'>
                    <el-option v-for="(item,index) in shopList" :key='index' :value="item.id" :label="item.name"></el-option>
                </el-select>
			</div> -->
			<div class="input-box">
				<span>销售门店：</span>
				<el-select
					size="mini"
					class="name-input"
					v-model="shopNameIds"
					filterable
					multiple
					collapse-tags
					placeholder="请选择门店名称">
					<template v-for="item in shopNameList">
						<el-option
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</template>
				</el-select>
			</div>
      <div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productname"
					placeholder="请输入商品、规格名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>SPU编号：</span>
				<el-input
					v-model="pcode"
					placeholder="请输入SPU编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box">
				<span>SKU编号：</span>
				<el-input
					v-model="speccode"
					placeholder="请输入SKU编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box">
				<span>三方编号：</span>
				<el-input
					v-model="matchcode"
					placeholder="请输入三方编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box">
				<span>私密状态：</span>
        <el-select v-model="privateproductFlag" placeholder="请选择私密状态" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="公开"></el-option>
					<el-option :value="1" label="私密"></el-option>
				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					plain
					@click="search">查找</el-button>
			</div>
		</div>
        <div class="table-box">
            <el-table
				:stripe='true'
				ref='multipleTable'
				class="grid-content"
				:data="tableData"
                size='mini'
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange">
				<el-table-column
				fixed='left'
				type="selection"
				align="center"
				width="55">
				</el-table-column>
					<el-table-column
						label-class-name = "column-index"
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
					<el-table-column
						prop="sName"
						label="销售门店"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="pName"
						label="商品名称"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="pCode"
						label="SPU编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="matchcode"
						label="三方编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格名称"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="speccode"
						label="SKU编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
					prop="hiddenFlag"
					label="私密状态"
					align="center"
					min-width="100">
						<template slot-scope="scope">
							<span v-if="!scope.row.hiddenflag">公开</span>
							<span v-else>私密</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="defaultPrice"
						label="默认价格"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="spePrice"
						label="专用价格"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<el-input size='mini' v-model="scope.row.spePrice" @change="spePriceChange(scope.row)" type='number'></el-input>
						</template>
					</el-table-column>
					<el-table-column
						label="有效日期"
						align="center"
						min-width="380">
						<template slot-scope="scope">															<!-- :picker-options="pickerOptions" -->
							<el-date-picker
								size='mini'
								:unlink-panels='true'
								@change="dateChange(scope.row)"
								value-format='yyyy-MM-dd'
								v-model="scope.row.dateValue"
								:clearable='false'
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>

						</template>
					</el-table-column>

			</el-table>
			<div class="page-box">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
			</div>
        </div>
         <div class="binding-foot">
            <el-button class="btn" plain type="primary" size='small' @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary"  size='small' @click="saveClick">确认添加</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'addModal',
	props: {
		addModal: Boolean,
		syscode: String,
		customerName: String
	},
	data () {
		return {
			shopid: '',
			shopname: '',
			shopList: [],
			productname: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			ids: [],
			tableHeight: '90%',
			privateproductFlag: -1,
			pcode: '',
			matchcode: '',
			speccode: '',
			shopNameIds: [],
			shopNameList: []
		}
	},
	watch: {
		addModal: {
			handler (val) {
				if (val) {
					this.productname = ''
					this.privateproductFlag = -1
					this.pcode = ''
					this.matchcode = ''
					this.speccode = ''
					this.shopNameIds = []
					this.getShop()
					this.getShopList()
				}
			},
			immediate: true
		}
	},
	methods: {
		dateChange (data) {
			if (data.dateValue === null) {
				let a = new Date()
				let b = a.setFullYear(a.getFullYear() + 1)
				let c = this.$fxUtils.setDate(a)
				let d = new Date()
				let e = this.$fxUtils.setDate(d)
				console.log(e, c, b)
				data.dateValue = [e, c]
			}
			console.log(data)
		},
		spePriceChange (data) {
			if (data.spePrice === '') {
				data.spePrice = data.defaultPrice
			} else {
				data.spePrice = this.$fxUtils.toFixedSHW(data.spePrice, 2)
			}
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			let a = this.ids
			let b = []
			let logArr = []
			if (a.length > 0) {
				for (let i = 0; i < a.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (a[i] === this.tableData[j].ppId) {
							this.tableData[j].syscode = this.syscode
							this.tableData[j].beginDate = this.tableData[j].dateValue[0]
							this.tableData[j].endDate = this.tableData[j].dateValue[1]
							b.push(this.tableData[j])
							logArr.push(this.tableData[j].pName)
							break
						}
					}
				}
			} else {
				this.$message.error('请选择商品！')
				return false
			}
			let changeData = {
				pre: { pName: {} },
				cur: { pName: { names: logArr.join(','), customerName: this.customerName } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveCustomerSpecialPrice`,
				data: b,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionChange (data) {
			console.log(data)
			this.ids = []
			if (data.length > 0) {
				for (let i = 0; i < data.length; i++) {
					this.ids.push(data[i].ppId)
				}
			}
		},
		search () {
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getAllShopBySyscodeId`
			}).then(res => {
				if (res.result) {
					this.shopList = res.data
					if (res.data.length > 0) {
						this.shopid = res.data[0].id
					}
					this.$nextTick(() => {
						this.tableReload()
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		tableReload () {
			if (this.shopid === '') {
				// this.$message.error('请选择销售门店')
				return false
			}
			let a = this.shopList
			for (let i = 0; i < a.length; i++) {
				if (this.shopid === a[i].id) {
					this.shopname = a[i].name
				}
			}
			let params = {
				shopid: this.shopid,
				shopname: this.shopname,
				productname: this.productname,
				page: this.page.number,
				size: this.page.size,
				privateproductflag: this.privateproductFlag,
				pcode: this.pcode,
				matchcode: this.matchcode,
				speccode: this.speccode,
				relShopIdList: this.shopNameIds
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getPriceOfProduct`,
				data: params
			}).then(res => {
				if (res.result === true) {
					console.log(res)
					let list = res.data.recordList || []
					list.forEach(item => {
						item.dateValue = [item.beginDate, item.endDate]
						item.defaultPrice = this.$fxUtils.toFixedSHW(item.defaultPrice, 2)
						item.spePrice = this.$fxUtils.toFixedSHW(item.spePrice, 2)
					})
					this.tableData = JSON.parse(JSON.stringify(list))
					this.total = res.data.recordCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
				// console.log(res)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
  display: flex;
  width: 100%;
	flex-direction: column;
  height :600px;
  overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :240px;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
    .table-box{
		width :100%;
        padding-bottom :10px;
        height:calc(100% - 130px);
		.page-box{
			margin-top:10px
			text-align :center
		}
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
